import {Add} from 'components/grid-dx/consult-buttons';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {Roles} from '../../../../app/Constants';
import IntegrityRoleGrid from '../../../../components/UserRole';
import {useGetProfiles, useLoadProfilesToRequirement} from '../hooks/index';
import {ADD_PROFILE} from '../types';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

const Buttons = ({data}: any) => {
  const profiles = useGetProfiles();
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  let hidden: boolean = false;
  if (profiles.length > 0) {
    hidden = profiles.find((x: any) => x.iD_Profile === data.iD_Profile);
  }
  if (hidden) return null;

  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <Add row={data} type={ADD_PROFILE} />
    </div>
  );
};

const SelectProfilesGrid = (props: any) => {
  const loadProfiles = useLoadProfilesToRequirement();
  const isTablet = useIsTablet();

  return (
    <>
      <IntegrityRoleGrid
        allowEdit={Roles.AdminITPS}
        dataSource={loadProfiles}
        allowActions={false}
        allowIntegrity={false}
        width="600px"
        height="70vh"
        shouldSaveFilters={true}
        id={['iD_Profile']}>
        <Column
          caption={i18n2._('#Profile')}
          visible={false}
          dataField="iD_Profile"
        />
        <Column
          caption={i18n2._('Nombre')}
          dataField="profile_Name"
          width={200}
        />
        <Column
          caption={i18n2._('#Sector')}
          visible={false}
          dataField="iD_Sector"
          width={100}
        />
        <Column
          caption={i18n2._('Nombre del sector')}
          dataField="sector_Name"
        />
        <Column
          caption=""
          cellComponent={(e: any) => <Buttons data={e.data.data} />}
          width={getActionColumnWidth(1, isTablet)}
          fixed
          alignment="right"
        />
      </IntegrityRoleGrid>
    </>
  );
};

export default SelectProfilesGrid;
